import Popup from '@/components/popup'
import { useTranslation } from 'react-i18next'
import { GetCatgoryLookup, GetServiceTypeLookUp } from '@/api/endpoints'
import { AddServiceCategory, GetserviceCatgoryById, updateServiceCategory } from '@/api/endpoints'
import { SERVICES_TYPES } from '@/data/Constant'
import useForm from '@/hooks/useForm'
import { DropDown, FileUpload, MLInputField } from '@/components/Exporter'
import { LoadListDefault, useGet, usePost, useUpdate } from '@/api/hooks'
import { convertToFormData } from '@/hooks/useFormData'
import { SUPPORTED_FORMATS } from '@/components/popups/filesUploadPopup/components/UploadFile'
import { useState } from 'react'

const modalName = 'service-category-modal'

const ReqObject = (data) => {
    return convertToFormData(data)
}

const GetCatgories = (Id) => GetCatgoryLookup(Id)


const commontFieldsProps = (name, value, setValue, isRequired = false) => ({
    className: "col-md-6",
    accept: [SUPPORTED_FORMATS.image],
    multiple: false,
    isRequired,
    name,
    label: name,
    setValue,
    value,
})

const CUServiceCategory = ({ RecordID, modalID }) => {

    const { formHandler, onSubmit } = useForm()
    const [files, setFiles] = useState({
        image: [],
        icon: [],
    })

    const { onPost, loading: isLoadingPost } = usePost(AddServiceCategory)
    const { onUpdate, loading: isLoadingUpdate } = useUpdate(updateServiceCategory)

    const { result: serviceCatgoryData } = useGet({
        ...LoadListDefault,
        defaultValue: {},
        endPoint: GetserviceCatgoryById,
        params: [RecordID],
        allowFetch: !!RecordID,
    })


    const { t } = useTranslation()


    const handleSubmit = () => {
        onSubmit((data) => {
            const reqObject = ReqObject({
                ServiceTypeId: data?.serviceCatType?.value ?? data?.serviceCatType,
                ParentCategoryId: data?.serviceCatParentType?.value ?? data?.serviceCatParentType,
                NameEN: data?.serviceCatNameEn,
                Name: data?.serviceCatName,
                Image: files.image?.[0],
                Icon: files.icon?.[0]
            })

            RecordID ? onUpdate(RecordID, reqObject, () => modalID.current.click()) : onPost(reqObject, () => modalID.current.click())
        })
    }

    return (
        <Popup name={`${modalName}_${RecordID}`} recordID={RecordID} modalID={modalID} onApply={handleSubmit} title={`${t(`${modalName}`)} ${RecordID ? `# ${RecordID}` : ""}`}>
            <MLInputField formHandler={formHandler} name="serviceCatName" defaultValue={serviceCatgoryData} />

            <DropDown isMulti={false} formHandler={formHandler} label="serviceCatType" endPoint={GetServiceTypeLookUp} defaultValue={serviceCatgoryData?.serviceTypeId} />
            <DropDown isMulti={false} formHandler={formHandler} label="serviceCatParentType" endPoint={() => GetCatgories(SERVICES_TYPES.Medical)} defaultValue={serviceCatgoryData?.parentCategoryId} />
           
            <FileUpload {...commontFieldsProps('serviceCatImage', files.image, (value) => setFiles((prev) => ({ ...prev, image: value })), !RecordID)} />
            <FileUpload {...commontFieldsProps('ServiceCategoryIcon', files.icon, (value) => setFiles((prev) => ({ ...prev, icon: value })), !RecordID)} />


        </Popup >
    )
}



export default CUServiceCategory
